import React from "react";
import { Container } from "react-bootstrap";
import cta from "../../../../Asset/service-sec-5-CTA.webp";
import { useNavigate } from "react-router-dom";

const Last = () => {
  const navigate = useNavigate();

  const hendleClick = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section
        className="companyover-section-5"
        style={{ backgroundColor: "var(--light-primary-bg)" }}
      >
        <Container>
          <div
            className="row sec-5-row"
            style={{ backgroundColor: "var(--white-color)" }}
          >
            <div className="col-xl-8 col-md-8 cta-content">
              <div className="sec-5-cta-card">
                <h3>
                  <span className="text-blue">
                    Transform your business with us.
                  </span>
                  <br />
                  Ready to begin your journey? Get in touch to discover how we
                  can help you grow.
                </h3>
                <p onClick={hendleClick} className="btn btn-primary">
                  Let's Talk
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 cta-img">
              <div className="cta-bg">
                <img src={cta} className="w-100" alt="cta" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Last;
